import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LogoXINGLogoBlack, LogoXINGLogoDuo, LogoXINGLogoInvert, LogoXINGLogoWhite, } from '@xingternal/illustrations';
import { Styled } from './xing-logo.styles';
const DEFAULT_SIZE = 106;
export const XingLogo = ({ className, inverted = false, size = DEFAULT_SIZE, variant = 'duo', ...props }) => {
    const width = size;
    const height = Math.round((31 * size) / DEFAULT_SIZE); // Calculate height of logo from viewBox
    const defaultProps = {
        height,
        width,
    };
    return (_jsxs(Styled.XingLogo, { className: className, "data-xds": "XingLogo", children: [variant === 'duo' && !inverted && (_jsx(LogoXINGLogoDuo, { ...defaultProps, ...props })), variant === 'duo' && inverted && (_jsx(LogoXINGLogoInvert, { ...defaultProps, ...props })), variant === 'mono' && !inverted && (_jsx(LogoXINGLogoBlack, { ...defaultProps, ...props })), variant === 'mono' && inverted && (_jsx(LogoXINGLogoWhite, { ...defaultProps, ...props }))] }));
};
XingLogo.displayName = 'XingLogo';
//# sourceMappingURL=xing-logo.js.map